import { Link } from "react-router";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { diasParaExclusao } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";

/**
 * Organização com exclusão agendada: a faixa diz quando e que está só leitura. O proprietário
 * desfaz daqui ou vai à seção pra exportar os dados.
 */
export function FaixaDeExclusao({ prevista, proprietario }: { prevista: Date | string; proprietario: boolean }) {
  const utils = trpc.useUtils();
  const desfazer = trpc.organization.exclusao.desfazer.useMutation({
    onSuccess: () => {
      toast.success("Exclusão desfeita. A organização voltou ao normal.");
      utils.invalidate();
    },
    onError: (e) => toast.error(e.message || "Não foi possível desfazer."),
  });
  const data = new Date(prevista);
  const dias = diasParaExclusao(data, new Date());
  const quando = dias <= 1 ? "em menos de um dia" : `em ${dias} dias`;
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-red-600 px-4 py-1.5 text-[12.5px] font-medium text-white">
      <Trash2 className="h-3.5 w-3.5 shrink-0" />
      <span>
        Esta organização será excluída {quando} ({data.toLocaleDateString("pt-BR")}) · só leitura até lá
      </span>
      {proprietario && (
        <>
          <Link to="/configuracoes/exclusao" className="rounded-md px-2 py-0.5 text-xs font-semibold underline underline-offset-2 hover:bg-red-700">
            Exportar os dados
          </Link>
          <button
            type="button"
            disabled={desfazer.isPending}
            onClick={() => desfazer.mutate()}
            className="inline-flex items-center gap-1 rounded-md bg-white px-2.5 py-0.5 text-xs font-semibold text-red-700 hover:bg-red-50 disabled:opacity-60"
          >
            {desfazer.isPending && <Loader2 className="h-3 w-3 animate-spin" />}
            Desfazer
          </button>
        </>
      )}
    </div>
  );
}
